
import { useState, useEffect } from 'react';
import heroBanner1 from '../../../assets/hero-banner-1.png';
import heroBanner2 from '../../../assets/hero-banner-2.png';
import heroBanner3 from '../../../assets/hero-banner-3.png';

const bannerSlides = [
  {
    bg: heroBanner1,
  },
  {
    bg: heroBanner2,
  },
  {
    bg: heroBanner3,
  },
];

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % bannerSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="pt-[130px] md:pt-[148px]">
      <div className="container mx-auto px-4 max-w-7xl pb-4 md:pb-6">
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-black text-white leading-tight" style={{ fontFamily: 'Orbitron, sans-serif' }}>
          Kingbet9 Australia Mobile Casino - Best Online Slots &amp; Games
        </h1>
        <p className="mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-gray-300">
          Play Kingbet9 slot pokies, Kingbet9 live table casino and Kingbet9 fishing games from JILI, BNG and VPower.
        </p>
      </div>
      <div className="relative overflow-hidden">
        {bannerSlides.map((slide, index) => (
          <div
            key={index}
            className={`transition-opacity duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0 absolute inset-0'}`}
          >
            <div className="relative w-full h-[200px] sm:h-[320px] md:h-[440px]">
              <img
                src={slide.bg}
                alt={`Kingbet9 Australia casino banner ${index + 1}`}
                className="w-full h-full object-fill object-top"
              />
            </div>
          </div>
        ))}

        {/* Dots */}
        <div className="hidden md:flex absolute bottom-3 sm:bottom-5 left-1/2 -translate-x-1/2 gap-2 z-10">
          {bannerSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${index === currentSlide ? 'bg-yellow-400 w-6 sm:w-8' : 'bg-white/40 w-2'}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
